export default __webpack_public_path__ + "static/media/leg-right-back.b2785fbd.png";